import { render, staticRenderFns } from "./IconWellFedElephant.vue?vue&type=template&id=0af7169a&scoped=true&"
import script from "./IconWellFedElephant.vue?vue&type=script&lang=js&"
export * from "./IconWellFedElephant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af7169a",
  null
  
)

export default component.exports